import { get } from "@/backend";
import useSWR, { SWRConfiguration } from "swr";
const useTeam = (
  name: string,
  options?: SWRConfiguration & { invitation?: boolean },
) => {
  const { data, error, mutate } = useSWR(
    name ? `v1/teams/${name}${options?.invitation ? "/invitation" : ""}` : null,
    get,
    { ...options },
  );

  return {
    team: (!options?.invitation && data?.data) || { name },
    invitation: (options?.invitation && data?.data) || { team: { name } },
    loading: !data?.data && !error,
    error: !data?.data && error,
    mutate,
  };
};
export default useTeam;
